import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHugEmojiSecondary from './svgs/HugEmojiSecondary.js';
import SvgHugEmoji from './svgs/HugEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hugEmoji = (props => useIcon(SvgHugEmoji, SvgHugEmojiSecondary, props));

export { hugEmoji as default };
